import { MMSwitchInput as LibraryInput } from 'mmfintech-portal-commons'
import type { MMSwitchInputProps } from 'mmfintech-portal-commons/types'

type SwitchVariant = 'default'

type Props = Omit<MMSwitchInputProps<SwitchVariant>, 'size'>

export const MMSwitchInput = (props: Props) => {
  return <LibraryInput {...props} />
}
